exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._769rjo-61rXN8qH5dHOB1{margin-top:6vh;display:grid;grid-template-rows:79vh;grid-template-columns:repeat(auto-fit, minmax(300px, 1fr))}\n", ""]);
// Exports
exports.locals = {
	"main": "_769rjo-61rXN8qH5dHOB1"
};